import type { ReactElement, ReactNode } from 'react';
import { NavLink } from 'react-router';
import { useOrg } from '../api/queries';

/**
 * Board 09's frame: a sidebar of what exists — nothing on it is a stub — and
 * one page at a time. YOU is yours; ORGANISATION is the workspace's, and
 * shows for everyone (reading is allowed; changing is an administrator's).
 */
export function SettingsLayout({
  title,
  sub,
  aside,
  children,
}: {
  title: string;
  sub?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
}): ReactElement {
  const org = useOrg();
  const link = (to: string, label: string, end = false) => (
    <NavLink to={to} end={end} className={({ isActive }) => (isActive ? 'on' : '')}>
      {label}
    </NavLink>
  );
  return (
    <div className="page settings">
      <nav className="settings-nav" aria-label="Settings">
        <span className="eyebrow">You</span>
        {link('/settings', 'Recording', true)}
        {link('/settings/notifications', 'Email and Slack')}
        {link('/settings/connected', 'Connected apps')}
        {link('/settings/import', 'Import')}
        <span className="eyebrow">{org.data?.name ?? 'Organisation'}</span>
        {link('/settings/organisation', 'People and roles', true)}
        {link('/settings/organisation/defaults', 'Recording defaults')}
        {org.data?.canAdminister ? link('/settings/organisation/log', 'What has happened') : null}
      </nav>
      <div className="stack-lg">
        <div className="page-head" style={{ marginBottom: 0 }}>
          <div className="stack" style={{ gap: 4 }}>
            <h1 className="t-title">{title}</h1>
            {sub ? <p className="mono">{sub}</p> : null}
          </div>
          {aside}
        </div>
        {children}
      </div>
    </div>
  );
}
